import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxTranslateInModule } from 'ngx-translate-in';
import { MaterialModule } from 'src/app/shared/material.module';
import { DhhpComponentModule } from './dhhp-component.module';
import { GlobalNavPanelModule } from '../core/global-nav-panel/global-nav-panel.module';

@NgModule({
  imports: [
    CommonModule,
    NgxTranslateInModule,
    MaterialModule
  ],
  exports: [
    MaterialModule, DhhpComponentModule, GlobalNavPanelModule
  ],
  declarations: [
  ],
})
export class SharedModule { }
